import {
  SignInType,
  type SessionMetadata,
  type SessionMetadataResponse,
} from '@bbkAdminRedux/rtkq/auth-types';

export type DevSignInArgs = {
  email: string;
  pw: string;
};

type DevErrorResponse = {
  metadata?: {
    error?: {
      type?: string;
    };
  };
};

export class AuthDev {
  public async signIn({ email, pw }: DevSignInArgs): Promise<SessionMetadata> {
    const response = await fetch('/dev/login', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        email,
        password: pw,
      }),
    });

    const result = (await response.json()) as
      | SessionMetadataResponse
      | DevErrorResponse;
    if (!response.ok) {
      throw {
        code: (result as DevErrorResponse).metadata?.error?.type,
        message: 'Incorrect username or password.',
      };
    }

    // The backend set the HttpOnly session cookie and returned only metadata.
    return {
      type: SignInType.DEV,
    };
  }
}
